<script lang="ts" setup>
import type { FilterGroupMultiSelect } from "~~/models/filters";
import type { CatalogPageRecord } from "~~/server/graphql/datocms/generated";

defineProps<{ cmsData: CatalogPageRecord }>();

const { loggedIn } = useUserSession();

const { searchState, activeFilters, pagination } = useCatalog({
  initialize: {
    searchState: false,
    catalog: false,
    ssr: !loggedIn.value,
    scrollIntoViewThreshold: 500,
  },
});
</script>

<template>
  <div class="gap-md hidden flex-col lg:flex">
    <div class="gap-md flex flex-wrap items-center justify-between">
      <div class="gap-sm flex flex-wrap">
        <MultiSelectFilter
          v-for="filterGroup of searchState.propertyFilters" :key="filterGroup.title"
          :filter-group="filterGroup as FilterGroupMultiSelect" size="lg"
        />
      </div>

      <div v-if="pagination.totalItems > 0">
        <ProductSearchSort size="lg" />
      </div>
    </div>

    <div v-if="activeFilters.length" class="p-md gap-xl flex rounded-md bg-neutral-50">
      <ProductSearchFiltersActive :cms-data="cmsData" />
    </div>
  </div>
</template>

<style scoped>

</style>
